<script>
import { removeScheme } from '@/app/library/removeScheme';

const EMPTY_VALUE = 'None';

export default {
  name: 'PropertyValue',
  props: {
    value: {
      type: String,
      default: ''
    },
    transform: {
      type: String,
      default: 'plain',
      validator: (value) => ['plain', 'link'].includes(value)
    }
  },
  methods: {
    transformValue() {
      switch (this.transform) {
        case 'link':
          return this.transformValueToLink();
        case 'plain':
          return this.renderValue(this.value);
        default:
          break;
      }
    },
    transformValueToLink() {
      const linkWithRemovedScheme = removeScheme(this.value);

      if (!linkWithRemovedScheme) {
        return this.renderValue(linkWithRemovedScheme);
      }

      return (
        <el-link
          class='el-text el-text--body-24 p-property-value__link'
          href={ this.value }
          target='_blank'
        >
          <span class="el-text--ellipsis">{ linkWithRemovedScheme }</span>
          <el-icon name="i-external-link--16" />
        </el-link>
      );
    },
    renderValue(renderedValue) {
        return (
            <div class='el-text el-text--body-24 el-text--break'>
              { renderedValue || EMPTY_VALUE }
            </div>
          );
      }
  },
  render() {
    return this.transformValue();
  }
};
</script>

<style lang="scss" scoped>
.p-property-value__link {
  display: flex;
  align-items: center;
}
</style>
